import { useMutation } from '@tanstack/react-query';

import type {
  ClientCertificateRedeemData,
  MutationResponse,
} from '@/types/api/mutations';

import { HttpClient } from '@/network/HttpClient';

export const useRedeemClientCertificateMutation = () =>
  useMutation({
    mutationFn: (params: { url: string; data: ClientCertificateRedeemData }) =>
      HttpClient.request<MutationResponse>({
        method: 'POST',
        url: params.url,
        data: params.data,
      }),
  });
